module.exports = __webpack_public_path__ + "media/luxury-2026/twilight-modern-960-f63b0ca6.jpg";